module.exports = __webpack_public_path__ + "img/rent-2.c076f86a.png";